import React from 'react';

const DisclaimerPage = () => {
  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px'
    },
    title: {
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      color: '#1a1a2e',
      marginBottom: '10px'
    },
    date: {
      color: '#666',
      marginBottom: '30px'
    },
    section: {
      marginBottom: '30px'
    },
    heading: {
      fontSize: '1.3rem',
      color: '#1a1a2e',
      marginBottom: '15px'
    },
    text: {
      color: '#555',
      lineHeight: 1.7,
      marginBottom: '15px'
    },
    highlight: {
      background: '#fff3e0',
      border: '1px solid #ffcc80',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '20px'
    },
    highlightText: {
      color: '#e65100',
      fontWeight: '600',
      margin: 0
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Disclaimer</h1>
      <p style={styles.date}>Last Updated: January 2026</p>

      <div style={styles.highlight}>
        <p style={styles.highlightText}>
          ⚠️ Rx.ChatWithDr is NOT insurance. This is a prescription discount program.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Not Insurance</h2>
        <p style={styles.text}>
          The Rx.ChatWithDr discount card program is NOT insurance and is not intended to replace 
          insurance. If you have health insurance, compare the discount price to your insurance 
          copay to determine the best option. You cannot use both the discount card and insurance 
          for the same prescription.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Pricing Estimates</h2>
        <p style={styles.text}>
          All prices displayed on this website are estimates and may vary from actual pharmacy 
          prices. Factors that may affect final pricing include drug manufacturer changes, 
          pharmacy pricing decisions, and available inventory. Always confirm the final price 
          with your pharmacist before making a purchase.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>No Guaranteed Savings</h2>
        <p style={styles.text}>
          While our users often save significantly on their prescriptions, we cannot guarantee 
          specific savings amounts. Savings may vary based on the medication, pharmacy, and 
          other factors. The "up to 80% savings" referenced is based on average user savings 
          and is not guaranteed for every prescription.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Medical Disclaimer</h2>
        <p style={styles.text}>
          Rx.ChatWithDr provides prescription pricing information only. We do not provide 
          medical advice, diagnosis, or treatment recommendations. Always consult with a 
          qualified healthcare provider for medical advice and before starting, stopping, 
          or changing any medication.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Pharmacy Participation</h2>
        <p style={styles.text}>
          While our discount card is accepted at over 67,000 pharmacies nationwide, not all 
          pharmacies participate in our program. We recommend calling ahead to confirm 
          acceptance before visiting a pharmacy.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Third-Party Links</h2>
        <p style={styles.text}>
          Our website may contain links to third-party websites. We are not responsible for 
          the content or privacy practices of these external sites.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Changes to This Disclaimer</h2>
        <p style={styles.text}>
          We may update this disclaimer from time to time. Continued use of our Service 
          after changes constitutes acceptance of the updated disclaimer.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Questions</h2>
        <p style={styles.text}>
          If you have questions about this disclaimer, please contact us at support@chatwithdr.com.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerPage;
